/* eslint-disable react-hooks/exhaustive-deps */
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ContainerField,
  ContainerFormField,
  ContainerInput,
  ContainerSubLabel,
  HelpText,
  Label,
} from './components';
import SimpleErrorMessage from './SimpleErrorMessage';

const SiNoInputContainer = ({
  children,
  label,
  name,
  helpText,
  initialShowInput = false,
  btnName = `show${name}`,
  onClickShow,
  subLabel = null,
  onLabel = 'SI',
  offLabel = 'NO',
}) => {
  const { register, unregister, setValue, watch } = useFormContext();

  const [showInput, setShowInput] = useState(initialShowInput);

  const onInit = async () => {
    register(btnName, null);
    const btnNameValue = watch(btnName);
    setValue(btnName, btnNameValue || false);
    setShowInput(btnNameValue || false);
  };

  useEffect(() => {
    onInit();
    return () => {
      unregister(btnName);
    };
  }, []);

  const onClickBtn = (show) => (event) => {
    event.preventDefault();
    setShowInput(show);
    onClickShow && onClickShow(show);
    setValue(btnName, show);
  };

  const validBtnClassNames = (equalTo) => {
    return classnames({ 'in-label': true, selected: equalTo === showInput });
  };

  const validInputSubLabel = (isSubLabel) => {
    return classnames({
      'col-9 col-md-10 ': isSubLabel !== null,
      'col-12': !isSubLabel,
    });
  };

  return (
    <ContainerFormField>
      <div>
        <Label>{label}</Label>
        <button className={validBtnClassNames(true)} onClick={onClickBtn(true)}>
          {onLabel}
        </button>
        <button className={validBtnClassNames(false)} onClick={onClickBtn(false)}>
          {offLabel}
        </button>
      </div>

      {showInput && (
        <ContainerInput className="container-fluid">
          <div className="row ">
            <ContainerField className={validInputSubLabel(subLabel)}>
              {children}
            </ContainerField>
            <ContainerSubLabel subLabel={subLabel} />
          </div>
          <HelpText>{helpText}</HelpText>
          <SimpleErrorMessage name={name} />
        </ContainerInput>
      )}
    </ContainerFormField>
  );
};

export default SiNoInputContainer;
